export const BannerAccordion = (function () {
	'use strict';

	function init() {
		const toggles = document.querySelectorAll('[data-landing-banner-toggle]')
		const root = document.querySelector('[data-banner-slide]')
		let active = 0
		let activeVideo = false
		toggles.forEach((button) => {
			const val = button.getAttribute('data-landing-banner-toggle')
			const video = button.parentNode.querySelector('video')
			button.addEventListener('click', () => {
				active = val === active ? 0 : val
				root.setAttribute('data-banner-slide', active)
				if (activeVideo) {
					const oldVid = activeVideo
					setTimeout(oldVid.pause.bind(oldVid), 200)
				}
				if (active) {
					activeVideo = video
					video.play()
				} else {
					activeVideo = false
				}
				setTimeout(() => {
					window.dispatchEvent(new Event('px-debounced-resize'))
				})
			})
		})
	}

	return {
		init: init,
	};
})();
